import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SubmitHandler } from "react-hook-form";
import { ICompte } from "../../../models/interfaces/ICompte";
import { Tab, Tabs } from "react-bootstrap";
import { IFormUtilisateurBO } from "../../../models/interfaces/IFormUtilisateurBO";
import { useFetchBOCompteQuery, useUpdateCompteBOMutation } from "../../../redux/slice/api/BO/compteApi";
import UtilisateurInformationsPersonnelBO from "./UtilisateurInformationsPersonnelBO";
import { toast } from "react-toastify";
import SocieteInformationsBO from "../components/SocieteInformationsBO";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";



const PageUtilisateurModifBO: React.FC = () => {

  let { Id } = useParams();
  Id = Id ?? "";
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  const [compte,setCompte] = useState<ICompte|undefined>(undefined);
  const [NomPrenom, setNomPrenom] = useState("");
  
  const { data: CompteResult} = useFetchBOCompteQuery(Id, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || Id === "",
  });

  const [
    updateCompte,
    {
    data : dataBOCompteUpdate,
    isSuccess: isSuccessUpdateCompte,
    error: errorUpdateCompte,
  }] = useUpdateCompteBOMutation();

useEffect(() => {
  if (CompteResult?.Compte) {
    setCompte(CompteResult?.Compte);
  }

}, [CompteResult])

useEffect(() => {
  if (errorUpdateCompte !== undefined) {
    toast.warn("Les modifications n'ont pas été prises en compte");
    //setUpdateError(errorUpdateBO)
  }
}, [errorUpdateCompte])

useEffect(() => {
    //Compterefetch();
    if (isSuccessUpdateCompte && dataBOCompteUpdate?.Return_IdType_Message === Type_Return_Message.Validation) {
      toast.success("Les modifications ont bien été prises en compte.");
     } else if (isSuccessUpdateCompte && dataBOCompteUpdate?.Return_IdType_Message === Type_Return_Message.Erreur) {
      if (dataBOCompteUpdate?.Return_Message !== "") {
        toast.error(dataBOCompteUpdate?.Return_Message );
      } else {
        toast.error("Les modifications n'ont pas été prises en compte");
      }
  }
}, [isSuccessUpdateCompte])

  const onSubmitUtilisateur: SubmitHandler<IFormUtilisateurBO> = (data) => {
    updateCompte(
      {
        ...data,
        Id:Id ? parseInt(Id) : -1,
        Login:data.Email,
      }
    );
  };

     // Active Tabs 
     const [activeTab, setActiveTab] = useState<string>("");

     useEffect(() => {
       // Get the saved tab from localStorage or default to 'home'
       const savedTab = localStorage.getItem('activeTab') || 'infosuser'; // Default to 'home'
       setActiveTab(savedTab);
     }, []);
   
     const handleTabSelect = (selectedTab : any) => {
       // Set the selected tab and save it to localStorage
       setActiveTab(selectedTab);
       localStorage.setItem('activeTab', selectedTab);
     };
   
     

  return (
  <>
   <div className="container text-center">
        <div className="row pt-3 pb-2">
          <div className="col col-12 ">
            <h2 className="titreModule titre-bleu"><i className="bi-person pe-2" />Utilisateur ({NomPrenom})</h2>
          </div>
        </div>
        <div className="row pt-3 pb-5">
          <div className="col col-md-10 offset-md-1 col-12 ">
    {compte && 
      <Tabs activeKey={activeTab} onSelect={handleTabSelect} id="uncontrolled-tab-example" className="onglet mb-3">
        

        {/* <Tab eventKey="infos" title="Informations utilisateurs" onClick={() => setcurrTabName("infos")}>
          <UtilisateurInformationsPersonnelBO Compte={compte} disable={true} handleEnregistrer={onSubmitUtilisateur} ReadOnlyServicePart={false} />
        </Tab> */}
        <Tab eventKey="infosuser" title="Informations utilisateurs">
          <UtilisateurInformationsPersonnelBO Compte={compte} setCompte={setCompte} disableEmail={true} handleEnregistrer={onSubmitUtilisateur} ReadOnlyServicePart={false} handleNomPrenom={setNomPrenom} />
        </Tab>
        <Tab eventKey="infossociete" title="Informations Société">
          <SocieteInformationsBO IdSociete={compte?.IdSociete ?? 0} ReadOnlyServicePart={true} />
        </Tab>

        
      </Tabs>
    }
      </div>
           </div>
           </div>
  </>
  )

}; 

export default PageUtilisateurModifBO;

